import React from 'react'

const SkipLink = () => (
  <a className="skip-main" href="#content" hidden>
    Skip to main content
  </a>
)

export default SkipLink
